import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "modal",
  id: "sc-modal",
  tabindex: "-1",
  "aria-labelledby": "sc-modal-label",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "sc-modal-label"
  }, "可能存在以下问题"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "close"
  })
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "list-group list-group-flush" }
const _hoisted_7 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 缺少[")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-info" }, "所属区域", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("]，可能影响信息传递的准确性。 ")
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "list-group-item"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 缺少[")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-info" }, "隔离类型", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("]，可能影响信息传递的准确性。 ")
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "list-group-item"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 缺少[")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-info" }, "求助人姓名", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("]，我们应该如何称呼您。 ")
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 3,
  class: "list-group-item"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 缺少[")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-info" }, "联系方式", -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode("]，如有后续跟进，平台无法及时联系您。 ")
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "modal-footer" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-info",
  "data-bs-dismiss": "modal"
}, "补充内容", -1)
const _hoisted_29 = { class: "sc-get-help" }
const _hoisted_30 = { class: "container" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col mt-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input04",
  class: "form-label"
}, "所属区域", -1)
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_36 = ["id", "value"]
const _hoisted_37 = ["for"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input05",
  class: "form-label"
}, "隔离类型", -1)
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_41 = ["id", "value"]
const _hoisted_42 = ["for"]
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input01",
  class: "form-label"
}, "求助人姓名", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input01-h",
  class: "form-text"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark" }, "(可选)"),
  /*#__PURE__*/_createTextVNode("后续联络需要 ")
], -1)
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input02",
  class: "form-label"
}, "求助内容", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input02-h",
  class: "form-text"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode("描述问题详情 ")
], -1)
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input03",
  class: "form-label"
}, "联系方式", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input03-h",
  class: "form-text"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark" }, "(可选)"),
  /*#__PURE__*/_createTextVNode("如果有后续跟进 ")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-info"
}, "发布", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_usage_info = _resolveComponent("usage-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (!_ctx.createModel.group)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, _hoisted_11))
                : _createCommentVNode("", true),
              (!_ctx.createModel.school)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_16))
                : _createCommentVNode("", true),
              (!_ctx.createModel.name)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_21))
                : _createCommentVNode("", true),
              (!_ctx.createModel.mobile)
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitContent(true)))
            }, "直接提交")
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_usage_info),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submitContent()), ["prevent"]))
            }, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryInfo.groups, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        name: "group-options",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createModel.group) = $event)),
                        type: "radio",
                        class: "btn-check",
                        autocomplete: "off",
                        id: `groups-option-${item.id}`,
                        value: item.id
                      }, null, 8, _hoisted_36), [
                        [_vModelRadio, _ctx.createModel.group]
                      ]),
                      _createElementVNode("label", {
                        class: "btn btn-outline-secondary px-1",
                        for: `groups-option-${item.id}`
                      }, _toDisplayString(item.name), 9, _hoisted_37)
                    ], 64))
                  }), 128))
                ])
              ]),
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pseudoQuarantineMap, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.id
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        name: "quarantine-options",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pseudoExtension.qt) = $event)),
                        type: "radio",
                        class: "btn-check",
                        autocomplete: "off",
                        id: `quarantine-option-${item.id}`,
                        value: item.id
                      }, null, 8, _hoisted_41), [
                        [_vModelRadio, _ctx.pseudoExtension.qt]
                      ]),
                      _createElementVNode("label", {
                        class: "btn btn-outline-info px-1",
                        for: `quarantine-option-${item.id}`
                      }, _toDisplayString(item.name), 9, _hoisted_42)
                    ], 64))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "basic-input01",
                  "aria-describedby": "basic-input01-h",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createModel.name) = $event)),
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, _ctx.createModel.name]
                ]),
                _hoisted_45
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  "aria-label": "描述问题详情",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createModel.content) = $event)),
                  autocomplete: "off",
                  rows: "3",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.createModel.content]
                ]),
                _hoisted_48
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  type: "tel",
                  class: "form-control",
                  id: "basic-input03",
                  "aria-describedby": "basic-input03-h",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createModel.mobile) = $event)),
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, _ctx.createModel.mobile]
                ]),
                _hoisted_51
              ]),
              _hoisted_52
            ], 32)
          ])
        ])
      ])
    ])
  ], 64))
}